export const slowSpring = {
  type: 'spring',
  stiffness: 150,
  damping: 30,
}

export const spring = {
  type: 'spring',
  stiffness: 100,
  damping: 30,
}
